import { render, staticRenderFns } from "./CantonTableView.vue?vue&type=template&id=0f87fae3"
import script from "./CantonTableView.vue?vue&type=script&lang=js"
export * from "./CantonTableView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports